import { useEffect, useRef } from "react"

export const useDataRefresh = (fetcher, deps = []) => {
  const fetcherRef = useRef(fetcher)
  fetcherRef.current = fetcher

  useEffect(() => {
    const onDataChanged = () => {
      fetcherRef.current()
    }
    window.addEventListener("data-changed", onDataChanged)
    return () => window.removeEventListener("data-changed", onDataChanged)
  }, [])
}
